!function() {
    "use strict";
    !function() {
        var e = {
            collectionId: "all_collections",
            items: {},
            timerId: {},
            add_left_fix: 0,
            init: function() {
                let inputs = document.querySelectorAll('.nm-easywholesale-qty')
                inputs.forEach((input) => {
                  input.readOnly = true
                });
                if (document.getElementById("nm-wholesale-page-type") ? this.page_or_product = document.getElementById("nm-wholesale-page-type") : (this.page_or_product = [],
                this.page_or_product.value = !1),
                this.qtyStep = 1,
                "page" == this.page_or_product.value ? document.getElementById("nm_wholesale_qtyStep_page") && (this.qtyStep = Number(document.getElementById("nm_wholesale_qtyStep_page").value),
                (0 == this.qtyStep || isNaN(this.qtyStep)) && (this.qtyStep = 1)) : document.getElementById("nm_wholesale_qtyStep_product") && (this.qtyStep = Number(document.getElementById("nm_wholesale_qtyStep_product").value),
                (0 == this.qtyStep || isNaN(this.qtyStep)) && (this.qtyStep = 1)),
                document.getElementById("nm_wholesale_qtyStep") && (this.qtyStep = Number(document.getElementById("nm_wholesale_qtyStep").innerHTML),
                (0 == this.qtyStep || isNaN(this.qtyStep)) && (this.qtyStep = 1)),
                "undefined" == typeof layoutValues)
                    return !1;
                layoutValues.currency.indexOf("inkl.") > -1 && (layoutValues.money_format = layoutValues.money_format.substring(layoutValues.money_format.indexOf("{{")) + " " + layoutValues.currency.substring(layoutValues.currency.indexOf("<p"))),
                document.getElementById("nm_ew_money_format") && (layoutValues.money_format = document.getElementById("nm_ew_money_format").innerHTML);
                var e = window.location.search.replace("?", "").split("&").reduce((function(e, t) {
                    var n = t.split("=");
                    return e[decodeURIComponent(n[0])] = decodeURIComponent(n[1]),
                    e
                }
                ), {});
                if (void 0 !== e.search && document.getElementById("nm-searchByProduct") && (document.getElementById("nm-searchByProduct").value = e.search),
                void 0 !== e.collection && document.getElementById("nm-wholesale-search-filter")) {
                    const t = document.querySelector("#nm-wholesale-search-filter").getElementsByTagName("option");
                    for (let n = 0; n < t.length; n++)
                        t[n].dataset.handle == e.collection && (t[n].selected = !0,
                        this.collectionId = t[n].value)
                }
                window.navigator.standalone;
                var t = window.navigator.userAgent.toLowerCase()
                  , n = (/safari/.test(t),
                /iphone|ipod|ipad/.test(t));
                if (document.getElementById("nm-searchByProduct") && n && document.getElementById("nm-searchByProduct").removeAttribute("readonly"),
                document.getElementById("nm_easywholesale_TotalSelectedItemsVar"))
                    var o = document.getElementById("nm_easywholesale_TotalSelectedItemsVar").innerHTML;
                else
                    o = "Total selected items:";
                if (document.getElementById("nm_easywholesale_ButtonAddToCartVar"))
                    var l = document.getElementById("nm_easywholesale_ButtonAddToCartVar").innerHTML;
                else
                    l = "Add to cart";
                if ("undefined" == typeof nm_easywholesale_show || nm_easywholesale_show) {
                    if (document.getElementById("nm-wholesale-fix"))
                        ;
                    else {
                        let e = document.createElement("div");
                        e.classList.add("nm-wholesale-main-fix"),
                        e.classList.add("nm-nice-select"),
                        e.innerHTML = '                    <div class="nm-wholesale-fix nm-nice-select nm-wholesale-background-fix" id="nm-wholesale-fix">                        <div class="nm-wholesale-fix-inner" id="nm-wholesale-fix-inner">                              <div class="nm-easywholesale-footer nm-easywholesale-page-footer nm-layout-border-color nm-wholesale-fix-footer" style="margin-top: 0px;">                                <div class="nm-easywholesale-selected nm-easywholesale-selected-page_fix nm-layout-text-color" style="margin-left:0px;">                                  ' + o + ' <span class="nm-total-selected-items">0</span>                                </div>                                <div class="nm-easywholesale-total-fix nm-layout-text-color nm-total-summ-selected">0</div>                            </div>                            <div class="nm-easywholesale-add-to-cart-container-page-fix">                                <button type="button" class="nm-wholesale-btn-add-to-cart nm-secondary-background-color" data-formname="page">                                  ' + l + "                                </button>                            </div>                        </div>                     </div>",
                        document.body.append(e);
                        let t = document.getElementById("nm-wholesale-fix");
                        t.parentElement;
                        t.style.display = "none"
                    }
                    var a = document.querySelectorAll(".nm-wholesale-table-container");
                    for (const e of a)
                        if (void 0 !== e.id) {
                            var s = e.dataset.productid;
                            1 * s > 0 && this.update_all_values(s, 1)
                        }
                    this.add_to_cart_btn(0),
                    this.bindEvents();
                    var i = document.querySelectorAll(".nm-easywholesale-qty");
                    for (const e of i)
                        void 0 !== e.id && (e.value = 0);
                    var d = document.querySelectorAll("select.nm-wholesale-filter");
                    for (const e of d) {
                        const t = e.getElementsByTagName("option");
                        for (let e = 0; e < t.length; e++)
                            "all_variants" === t[e].value && (t[e].selected = !0)
                    }
                    document.getElementById("nm-wholesale-spinner") && (document.getElementById("nm-wholesale-spinner").innerHTML = ""),
                    this.check_scroll(),
                    "undefined" != typeof layoutValues && this.summaryOfTotalOrder(),
                    "function" == typeof nm_easywholesale_custom_script && nm_easywholesale_custom_script(),
                    document.getElementById("nm-searchByProduct") && "" != document.getElementById("nm-searchByProduct").value && this.updateListProductsAfterChangeFilter(),
                    document.getElementById("nm-wholesale-search-filter") && "all_collections" != document.getElementById("nm-wholesale-search-filter").value && this.updateListProductsAfterChangeFilter();
                    d = document.querySelectorAll(".nm-easywholesale-header-page");
                    for (const e of d)
                        e.style.opacity = "1",
                        e.style.position = "relative",
                        e.style.zIndex = "1";
                    if (window.BOOMR) {
                        if ("Dawn" == window.BOOMR.themeName || "Studio" == window.BOOMR.themeName || "Taste" == window.BOOMR.themeName || "Origin" == window.BOOMR.themeName || "Crave" == window.BOOMR.themeName || "Publisher" == window.BOOMR.themeName || "Sense" == window.BOOMR.themeName || "Refresh" == window.BOOMR.themeName || "Colorblock" == window.BOOMR.themeName || "Ride" == window.BOOMR.themeName || "Craft" == window.BOOMR.themeName) {
                            d = document.querySelectorAll("variant-radios");
                            for (const e of d)
                                this.element_hide(e);
                            d = document.querySelectorAll("div.product-form__quantity");
                            for (const e of d)
                                this.element_hide(e);
                            d = document.querySelectorAll("product-form");
                            for (const e of d)
                                this.element_hide(e);
                            d = document.querySelectorAll("variant-selects");
                            for (const e of d)
                                this.element_hide(e)
                        }
                        if ("Venture" != window.BOOMR.themeName && "Debut" != window.BOOMR.themeName && "Narrative" != window.BOOMR.themeName && "Express" != window.BOOMR.themeName || (this.add_left_fix = 5),
                        "Taste" == window.BOOMR.themeName) {
                            var r = document.querySelectorAll(".nm-easywholesale-name");
                            for (const e of r)
                                e.classList.add("themeTaste")
                        }
                    }
                    var m = document.querySelector(".nm-easywholesale-name");
                    if (m) {
                        var c = ".nm-easywholesale-name .EasyStock-Text-Title { line-height: " + getComputedStyle(m).lineHeight + " !important; }"
                          , u = document.head || document.getElementsByTagName("head")[0]
                          , y = document.createElement("style");
                        u.appendChild(y),
                        y.type = "text/css",
                        y.styleSheet ? y.styleSheet.cssText = c : y.appendChild(document.createTextNode(c))
                    }
                    this.set_height_all()
                }
            },
            update_all_values: function(e, t=0) {
                var n = document.querySelectorAll(".nm-wholesale-table-item-" + e);
                for (const t of n)
                    if (void 0 !== t.classList && (t.classList.remove("nm-hideAllVisible"),
                    t.classList.remove("nm-hideAllVisible-" + e),
                    t.classList.remove("nm-noborder"),
                    "undefined" != typeof nm_easywholesale_discount && ("percentage" == nm_easywholesale_discount_type || "fixed_amount" == nm_easywholesale_discount_type))) {
                        var o = t.querySelector(".nm-easywholesale-price")
                          , l = t.querySelector(".nm-easywholesale-qty");
                        if (l) {
                            var a = l.dataset.price / 100
                              , s = this.formatMoney(a.toFixed(2), layoutValues.money_format);
                            "percentage" == nm_easywholesale_discount_type ? (s = a * (100 - nm_easywholesale_discount_value) / 100,
                            s = Math.ceil(100 * s) / 100,
                            s = this.formatMoney(s.toFixed(2), layoutValues.money_format)) : "fixed_amount" == nm_easywholesale_discount_type && (s = (s = a - 1 * nm_easywholesale_discount_value) <= 0 ? document.getElementById("nm-easywholesale-page-delivery-free").innerHTML : this.formatMoney(s.toFixed(2), layoutValues.money_format)),
                            o.innerHTML = "<span class='for_discount_price'>" + this.formatMoney(a.toFixed(2), layoutValues.money_format) + "</span> " + s
                        }
                    }
                if ("undefined" != typeof nm_easywholesale_discount && ("percentage" == nm_easywholesale_discount_type || "fixed_amount" == nm_easywholesale_discount_type)) {
                    var i = document.querySelector("#nm-wholesale-table-container-" + e)
                      , d = i.querySelector(".nm-wholesale-header-price");
                    if (d) {
                        var r = d.querySelector("span")
                          , m = d.dataset.pricemin / 100
                          , c = d.dataset.pricemax / 100
                          , u = this.formatMoney(m.toFixed(2), layoutValues.money_format)
                          , y = this.formatMoney(c.toFixed(2), layoutValues.money_format);
                        "percentage" == nm_easywholesale_discount_type ? (u = m * (100 - nm_easywholesale_discount_value) / 100,
                        u = this.formatMoney(u.toFixed(2), layoutValues.money_format),
                        y = c * (100 - nm_easywholesale_discount_value) / 100,
                        y = this.formatMoney(y.toFixed(2), layoutValues.money_format)) : "fixed_amount" == nm_easywholesale_discount_type && (u = (u = m - 1 * nm_easywholesale_discount_value) <= 0 ? document.getElementById("nm-easywholesale-page-delivery-free").innerHTML : this.formatMoney(u.toFixed(2), layoutValues.money_format),
                        y = (y = c - 1 * nm_easywholesale_discount_value) <= 0 ? document.getElementById("nm-easywholesale-page-delivery-free").innerHTML : this.formatMoney(y.toFixed(2), layoutValues.money_format));
                        var h = u + " - " + y;
                        u == y && (h = u);
                        let e = "";
                        1 == i.querySelector(".nm-wholesale-right-block").dataset.countvar && (d.style.display = "block",
                        e = "class='nm-primary-color' style='padding-left: 12px;'"),
                        d.innerHTML = "<span class='for_discount_price_header'>" + r.innerHTML + "</span><span " + e + "> " + h + "</span>"
                    }
                }
                var f = this.class_not(n, "nm-hide-this-row")
                  , p = 0;
                for (const t of f)
                    void 0 !== t.classList && (t.classList.add("nm-hideAllVisible"),
                    t.classList.add("nm-hideForCollapse"),
                    t.classList.add("nm-hideAllVisible-" + e),
                    t.classList.remove("nm-noborder"),
                    p++);
                p > 0 && f[0].classList.add("nm-noborder");
                var _ = document.querySelectorAll(".nm-hideAllVisible-" + e)
                  , w = 0;
                for (const n of _)
                    (w < layoutValues.VariantsPerPage || "page" == this.page_or_product.value) && void 0 !== n.classList && (n.classList.remove("nm-hideAllVisible"),
                    n.classList.remove("nm-hideAllVisible-" + e),
                    1 != t && 2 != t || n.classList.remove("nm-hideForCollapse"),
                    w++);
                this.show_hide_pagination_btn(e);
                var g = [".product-single__prices", ".product-single__price", ".product__price", ".product-meta"];
                if (0 == f.length) {
                    if (this.element_show(document.getElementById("nm-no-product-matched-" + e)),
                    1 == t) {
                        this.element_hide(document.getElementById("nm-wholesale-table-container-" + e)),
                        document.getElementById("nm-wholesale-table-container-" + e).classList.add("nm-hideProduct");
                        var v = this;
                        Object.keys(g).map((function(e) {
                            var t = document.querySelectorAll(g[e]);
                            0 != t.length && (".product-meta" == g[e] ? 0 == t[0].querySelectorAll("h1").length && v.element_show(t[0]) : v.element_show(t[0]))
                        }
                        )),
                        this.element_show(document.getElementById("nm-display-none-form")),
                        this.element_hide(document.getElementById("nm-display-whole"))
                    }
                } else if (this.element_hide(document.getElementById("nm-no-product-matched-" + e)),
                1 == t) {
                    this.element_show(document.getElementById("nm-wholesale-table-container-" + e)),
                    this.element_show(document.getElementsByClassName("nm-wholesale-main")[0]);
                    v = this;
                    if (Object.keys(g).map((function(e) {
                        var t = document.querySelectorAll(g[e]);
                        if (0 != t.length)
                            for (const n of t) {
                                if (".product-meta" == g[e])
                                    0 == n.querySelectorAll("h1").length && v.element_show(n);
                                else
                                    v.element_show(n)
                            }
                    }
                    )),
                    this.element_hide(document.getElementById("nm-display-none-form")),
                    "product" == this.page_or_product.value) {
                        var I = document.querySelectorAll("form");
                        if (0 != (I = this.class_not(I, "nm-easywholesale-form")).length) {
                            var E, B = 0;
                            for (const e of I) {
                                if (e.action.indexOf("/cart/add") > -1) {
                                    B = 1,
                                    E = e;
                                    break
                                }
                                e.action.indexOf("/cart") > -1 && (B = 1,
                                E = e)
                            }
                            1 == B && this.element_hide(E);
                            var b = document.querySelector("[data-nm-wholesale='after']");
                            b ? b.insertAdjacentHTML("afterEnd", document.getElementById("nm-display-whole").innerHTML) : 1 == B && E.insertAdjacentHTML("afterEnd", document.getElementById("nm-display-whole").innerHTML),
                            document.getElementById("nm-display-whole").innerHTML = "";
                            v = this;
                            setTimeout((function() {
                                var e = E.querySelectorAll("input, select");
                                for (const t of e)
                                    if (t.name.indexOf("properties[") > -1) {
                                        let e = t.cloneNode(!0)
                                          , n = document.getElementById("product_form_product");
                                        n.insertBefore(e, n.firstChild),
                                        v.element_hide(t)
                                    }
                            }
                            ), 1500);
                            let e = document.querySelectorAll(".nm-easywholesale-qty");
                            for (let t = 0; t < e.length; t++)
                                e[t].addEventListener("input", (function(e) {
                                    return e.preventDefault(),
                                    e.stopPropagation(),
                                    !1
                                }
                                )),
                                e[t].addEventListener("change", (function(e) {
                                    return e.preventDefault(),
                                    e.stopPropagation(),
                                    !1
                                }
                                ))
                        }
                    } else
                        this.element_show(document.getElementById("nm-display-whole"))
                }
                this.set_height(e),
                this.setShowMorevariantsText(e, t)
            },
            setShowMorevariantsText: function(e, t=0) {
                var n = document.querySelectorAll(".nm-wholesale-table-item-" + e).length
                  , o = document.querySelectorAll(".nm-hideAllVisible-" + e)
                  , l = this.class_not(o, "nm-hide-this-row")
                  , a = o.length
                  , s = l.length
                  , i = layoutValues.LayoutMoreVariantsText
                  , d = "%%variants_per_page%%"
                  , r = "%%total_variants%%";
                i.indexOf(d) > -1 && (i = a < layoutValues.VariantsPerPage ? i.replace(new RegExp(d,"g"), a) : i.replace(new RegExp(d,"g"), layoutValues.VariantsPerPage)),
                i.indexOf(r) > -1 && (i = i.replace(new RegExp(r,"g"), n)),
                0 == s ? (this.element_hide(document.getElementById("nm-wholesale-table-under-footer-" + e)),
                0 == t && document.getElementById("nm-wholesale-table-under-footer-collapse-" + e) && (this.element_show(document.getElementById("nm-wholesale-table-under-footer-collapse-" + e)),
                this.element_show(document.getElementById("nm-collapse-" + e)))) : (this.element_show(document.getElementById("nm-wholesale-table-under-footer-" + e)),
                this.element_show(document.getElementById("nm-showMoreVariants-" + e))),
                document.getElementById("nm-showMoreVariants-" + e) && (document.getElementById("nm-showMoreVariants-" + e).innerHTML = i)
            },
            add_to_cart_btn: function(e) {
                var t = document.querySelectorAll(".nm-wholesale-btn-add-to-cart");
                for (const n of t)
                    void 0 !== n.style && (1 == e ? (n.style.opacity = "1",
                    n.disabled = 0,
                    n.classList.add("nm-wholesale-btn-add-to-cart-enabled")) : (n.style.opacity = "0.4",
                    n.disabled = 1,
                    n.classList.remove("nm-wholesale-btn-add-to-cart-enabled")))
            },
            updateListProductsAfterChangeFilter: function() {
                var e = 0
                  , t = 0
                  , n = []
                  , o = document.querySelectorAll(".nm-wholesale-table-container")
                  , l = this.class_not(o, "nm-hideProduct");
                for (const o of l)
                    if (void 0 !== o.id) {
                        var a = o.dataset.collection
                          , s = o.dataset.title.toLowerCase()
                          , i = o.dataset.sku.toLowerCase();
                        if (a.indexOf(this.collectionId) > -1 || "all_collections" == this.collectionId) {
                            var d = document.getElementById("nm-searchByProduct").value.toLowerCase();
                            if (s.indexOf(d) + 1 || i.indexOf(d) + 1 || "" == d)
                                this.element_show(o),
                                e++;
                            else {
                                t = 1,
                                n = o.querySelectorAll(".nm-easywholesale-name");
                                for (const l of n)
                                    if (l.innerHTML.replace(/<small>.*?<\/small>/gi, "").toLowerCase().indexOf(d) + 1) {
                                        this.element_show(o),
                                        e++,
                                        t = 0;
                                        break
                                    }
                                1 == t && this.element_hide(o)
                            }
                        } else
                            this.element_hide(o)
                    }
                for (const e of o)
                    if (void 0 !== e.id) {
                        a = e.dataset.collection;
                        document.getElementById("nm-easywholesale-collection-head_" + a) && (a.indexOf(this.collectionId) > -1 || "all_collections" == this.collectionId ? this.element_show(document.getElementById("nm-easywholesale-collection-head_" + a)) : this.element_hide(document.getElementById("nm-easywholesale-collection-head_" + a)))
                    }
                var r = document.querySelectorAll(".nm-easywholesale-collection-head");
                for (const e of r)
                    void 0 !== e.id && (e.id.substring(33) == this.collectionId || "all_collections" == this.collectionId ? this.element_show(e) : this.element_hide(e));
                var m = document.getElementById("nm-no-search");
                0 == e ? this.element_show(m) : this.element_hide(m)
            },
            updateListAfterChangeFilter: function(e) {
                var t = ""
                  , n = 1
                  , o = document.querySelectorAll("select.nm-wholesale-filter-" + e);
                for (const e of o)
                    if (void 0 !== e.style) {
                        if ("all_variants" != e.value) {
                            let o = n;
                            void 0 !== e.dataset.num && (o = e.dataset.num),
                            t = t + "[data-option" + o + '="' + e.value + '"]'
                        }
                        n++
                    }
                for (var l = document.querySelectorAll(".nm-wholesale-table-item-" + e), a = 0; a < l.length; a++)
                    void 0 !== l[a].classList && l[a].classList.remove("nm-hide-this-row");
                if ("" != t) {
                    var s = document.querySelectorAll(".nm-wholesale-table-item-" + e + t);
                    for (a = 0; a < s.length; a++)
                        void 0 !== s[a].classList && s[a].classList.add("nm-not-hide");
                    for (a = 0; a < l.length; a++)
                        void 0 !== l[a].classList && (l[a].classList.contains("nm-not-hide") ? l[a].classList.remove("nm-not-hide") : l[a].classList.add("nm-hide-this-row"))
                }
                document.getElementById("nm-wholesale-table-under-footer-collapse-" + e) && this.element_hide(document.getElementById("nm-wholesale-table-under-footer-collapse-" + e))
            },
            show_hide_pagination_btn: function(e) {
                0 == document.querySelectorAll(".nm-hideAllVisible-" + e).length ? this.element_hide(document.getElementById("nm-wholesale-table-under-footer-" + e)) : this.element_show(document.getElementById("nm-wholesale-table-under-footer-" + e))
            },
            set_height_all: function() {
                var e = document.querySelectorAll(".nm-wholesale-table-container");
                for (const n of e)
                    if (void 0 !== n.id) {
                        var t = n.dataset.productid;
                        this.set_height(t)
                    }
                var n = document.querySelectorAll(".nm-wholesale-main")
                  , o = document.querySelectorAll(".nm-wholesale-main-fix");
                if (n[0] && o[0]) {
                    let e = n[0].getBoundingClientRect()
                      , t = e.left - 20
                      , a = 30;
                    t < 0 && (t = 0,
                    a = 20),
                    o[0].style.left = t + "px",
                    o[0].style.maxWidth = n[0].offsetWidth + a + "px";
                    var l = document.getElementById("nm-wholesale-fix-inner");
                    l.style.width = n[0].offsetWidth - 0 + "px";
                    let s = o[0].getBoundingClientRect();
                    l.style.left = e.left - 10 - s.left + "px",
                    l.style.left = this.add_left_fix + "px"
                }
            },
            set_height: function(e) {
                var t = 0;
                document.getElementById("nm-wholesale-table-container-" + e) && (t = (r = document.getElementById("nm-wholesale-table-container-" + e)).offsetWidth);
                var n = 0;
                document.getElementById("nm-wholesale-table-body-" + e) && (n = (r = document.getElementById("nm-wholesale-table-body-" + e)).offsetWidth);
                var o = "row"
                  , l = "155px"
                  , a = "0px"
                  , s = "100px";
                document.getElementById("nm_easywholesale_variant_as_product") && "1" == document.getElementById("nm_easywholesale_variant_as_product").value && (s = "0px");
                var i = "100px"
                  , d = "100px";
                if (0 == n && document.getElementById("nm-wholesale-table-container-all"))
                    n = (r = document.getElementById("nm-wholesale-table-container-all")).offsetWidth;
                if (n < 380 && (o = "column",
                l = "0px",
                a = "0px"),
                0 == t && document.getElementById("nm-wholesale-table-container-all")) {
                    var r;
                    t = (r = document.getElementById("nm-wholesale-table-container-all")).offsetWidth
                }
                t < 490 && (s = "0px",
                i = "0px",
                d = "0px");
                var m = document.getElementById("nm-easywholesale-table-and-header-" + e);
                m && (m.style.marginLeft = s);
                var c = r.querySelectorAll(".nm-easywholesale-name-and-price-only");
                for (const e of c)
                    void 0 !== e.id && (e.style.flexDirection = o);
                c = document.querySelectorAll(".nm-easywholesale-footer"),
                c = this.class_not(c, "nm-easywholesale-page-footer");
                for (const e of c)
                    void 0 !== e.id && (e.style.flexDirection = o);
                c = document.querySelectorAll(".nm-easywholesale-total");
                for (const e of c)
                    "page" == this.page_or_product.value ? e.style.paddingRight = a : e.style.paddingRight = l;
                c = document.querySelectorAll(".nm-easywholesale-selected-page");
                for (const e of c)
                    e.style.marginLeft = i;
                c = document.querySelectorAll(".nm-easywholesale-selected-page_fix");
                for (const e of c)
                    e.style.marginLeft = d;
                var u = document.querySelectorAll(".nm-wholesale-table-item-" + e)
                  , y = this.class_not(u, "nm-hide-this-row")
                  , h = this.class_not(y, "nm-hideAllVisible")
                  , f = 0
                  , p = 0
                  , _ = 0;
                for (const e of h)
                    (f < layoutValues.HeightRowsLimit || "page" == this.page_or_product.value) && (_ = e.offsetHeight,
                    "undefined" != typeof nm_easywholesale_easystock_enable && "inventory_text" != nm_easywholesale_easystock_enable && (_ = 150),
                    p += _),
                    f++;
                f > layoutValues.HeightRowsLimit ? p += _ / 2 : 0 == p ? p = 100 : p += 10,
                "undefined" != typeof nm_wholesale_nodetectmob ? r.style.maxHeight = p + "px" : this.detectMob() || "page" == this.page_or_product.value ? r.style.maxHeight = "none !important" : r.style.maxHeight = p + "px"
            },
            detectMob: function() {
                return [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i].some((e=>navigator.userAgent.match(e)))
            },
            class_not: function(e, t) {
                var n = [];
                for (const o of e)
                    void 0 !== o.classList && (o.classList.contains(t) || n.push(o));
                return n
            },
            element_show: function(e) {
                null != e && void 0 !== e.style && (e.style.display = "block")
            },
            element_hide: function(e) {
                null != e && void 0 !== e.style && (e.style.display = "none")
            },
            check_max_min: function(e, t, n) {
                var o = document.getElementById(n);
                "deny" == e && (this.items[n].quantity >= t ? (document.getElementById("nm-id-increase-" + n).style.opacity = "0.4",
                this.items[n].quantity = t) : document.getElementById("nm-id-increase-" + n).style.opacity = "1"),
                "continue" == e && (document.getElementById("nm-id-increase-" + n).style.opacity = "1"),
                this.items[n].quantity <= 0 ? (delete this.items[n],
                o.value = 0,
                document.getElementById("nm-id-decrease-" + n).style.opacity = "0.4") : (o.value = this.items[n].quantity,
                document.getElementById("nm-id-decrease-" + n).style.opacity = "1"),
                this.summaryOfTotalOrder()
            },
            check_input: function(e, t, n) {
                var o = document.getElementById(e)
                  , l = Number(o.dataset.inc)
                  , a = Number(o.dataset.quantity)
                  , s = o.dataset.policy;
                if (document.getElementById("nm-id-decrease-" + e).style.opacity = "1",
                document.getElementById("nm-id-increase-" + e).style.opacity = "1",
                void 0 === this.items[e]) {
                    var i = Number(o.dataset.price);
                    this.items[e] = {
                        quantity: 0,
                        price: i
                    }
                }
                if (t > -1) {
                    var d = this;
                    i = Number(o.dataset.price);
                    d.items[e] = {
                        quantity: 0,
                        price: i
                    },
                    d.items[e].quantity = Number(t),
                    d.check_max_min(s, a, e),
                    t = o.value,
                    void 0 !== d.timerId[e] && clearTimeout(d.timerId[e]),
                    d.timerId[e] = setTimeout((function(e, t) {
                        var n = document.getElementById(t)
                          , o = Number(n.dataset.price)
                          , l = Number(n.dataset.inc)
                          , a = Number(n.dataset.quantity)
                          , s = n.dataset.policy;
                        d.items[t] = {
                            quantity: 0,
                            price: o
                        };
                        let i = Number(e)
                          , r = Number(e);
                        l > 0 ? (i = Math.round(Math.ceil(i / l) * l),
                        r = Math.round(Math.floor(r / l) * l)) : d.qtyStep > 1 && (i = Math.round(Math.ceil(i / d.qtyStep) * d.qtyStep),
                        r = Math.round(Math.floor(r / d.qtyStep) * d.qtyStep)),
                        i >= a ? (d.items[t].quantity = r,
                        d.check_max_min(s, a, t)) : (d.items[t].quantity = i,
                        d.check_max_min(s, a, t))
                    }
                    ), 1e3, t, e)
                } else {
                    if (n < 0) {
                      if (e === 'nm-44346754203913' || e === 'nm-44346754236681') {
                          this.items[e].quantity = this.items[e].quantity + n;
                      } else if (e === 'nm-44368628384009' || e === 'nm-44368628416777') {
                        if (this.items[e].quantity - 1 < 12) {
                          this.items[e].quantity = 0;
                        } else {
                          this.items[e].quantity = this.items[e].quantity + n;
                        }
                      } else {
                        if (this.items[e].quantity - 1 < 4) {
                          this.items[e].quantity = 0;
                        } else {
                          this.items[e].quantity = this.items[e].quantity + n;
                        }
                      }
                    } else {
                      if (e === 'nm-44346754203913' || e === 'nm-44346754236681') {
                          this.items[e].quantity = this.items[e].quantity + n;
                      } else if (e === 'nm-44368628384009' || e === 'nm-44368628416777') {
                        if (this.items[e].quantity + 1 < 12) {
                          this.items[e].quantity = 12;
                        } else {
                          this.items[e].quantity = this.items[e].quantity + n;
                        }
                      } else {
                        if (this.items[e].quantity + 1 < 4) {
                          this.items[e].quantity = 4;
                        } else {
                          this.items[e].quantity = this.items[e].quantity + n;
                        }
                      }
                    }
                    let t = a;
                    l > 0 ? t = Math.round(Math.floor(t / l) * l) : this.qtyStep > 1 && (t = Math.round(Math.floor(t / this.qtyStep) * this.qtyStep)),
                    this.check_max_min(s, t, e)
                }
            },
            bindEvents: function() {
                var t = this;
                n = document.querySelectorAll(".nm-wholesale-filter");
                for (const e of n)
                    void 0 !== e.classList && e.addEventListener("change", (function() {
                        var e = this.dataset.id;
                        l(e),
                        t.updateListAfterChangeFilter(e),
                        t.update_all_values(e, 2);
                        var n = document.querySelectorAll("button[data-productid='" + e + "']");
                        "page" == t.page_or_product.value && t.element_hide(n[0])
                    }
                    ));
                n = document.querySelectorAll(".nm-wholesale-click-search");
                for (const e of n)
                    void 0 !== e.classList && e.addEventListener("click", (function() {
                        document.getElementById("nm-searchByProduct") && (document.getElementById("nm-searchByProduct").value = this.innerHTML,
                        t.updateListProductsAfterChangeFilter())
                    }
                    ));
                n = document.querySelectorAll(".nm-wholesale-search-filter");
                for (const e of n)
                    void 0 !== e.classList && e.addEventListener("change", (function() {
                        t.collectionId = this.value,
                        t.updateListProductsAfterChangeFilter()
                    }
                    ));
                for (var n = document.querySelectorAll(".nm-wholesale-show-more-variants"), o = 0; o < n.length; o++)
                    n[o].addEventListener("click", (function() {
                        var e = this.dataset.productid
                          , n = document.querySelectorAll(".nm-hideAllVisible-" + e);
                        t.set_height(e),
                        n.length <= layoutValues.VariantsPerPage && t.element_hide(document.getElementById("nm-wholesale-table-under-footer-" + e));
                        var o = 0;
                        for (const t of n)
                            o < layoutValues.VariantsPerPage && void 0 !== t.classList && (t.classList.remove("nm-hideAllVisible"),
                            t.classList.remove("nm-hideAllVisible-" + e),
                            o++);
                        n = document.querySelectorAll(".nm-hideAllVisible-" + e);
                        t.set_height(e),
                        t.setShowMorevariantsText(e);
                        let l = document.getElementById("nm-wholesale-table-body-" + e);
                        l.scrollTop = l.scrollHeight
                    }
                    ));
                for (n = document.querySelectorAll(".nm-wholesale-collapse"),
                o = 0; o < n.length; o++)
                    n[o].addEventListener("click", (function() {
                        var e = this.dataset.productid
                          , n = document.querySelectorAll("select.nm-wholesale-filter-" + e);
                        for (const e of n)
                            void 0 !== e.style && (e.value = "all_variants");
                        if (t.updateListAfterChangeFilter(e),
                        document.getElementById("nm-other-" + e)) {
                            t.element_hide(document.getElementById("nm-other-" + e));
                            n = document.querySelectorAll(".nm-view-other-" + e);
                            t.element_show(n[0])
                        }
                        t.element_hide(this);
                        let o = 1;
                        "undefined" != typeof nmWholesaleNotFullUpdate && 1 == nmWholesaleNotFullUpdate && (o = 0),
                        t.update_all_values(e, o),
                        "undefined" == typeof nmWholesaleNotScroll && t.smoothScrollTo(document.getElementById("nm-wholesale-table-container-" + e).offsetTop, 200)
                    }
                    ));
                for (n = document.querySelectorAll(".nm-easywholesale-qty-increase"),
                o = 0; o < n.length; o++)
                    n[o].addEventListener("click", (function() {
                        var e = this.dataset.id
                          , n = document.getElementById(e)
                          , o = Number(n.dataset.inc)
                          , l = t.qtyStep;
                        // console.log(t)
                        o > 0 && (l = o),
                        t.check_input(e, -1, l)
                    }
                    ));
                for (n = document.querySelectorAll(".nm-easywholesale-qty-decrease"),
                o = 0; o < n.length; o++)
                    n[o].addEventListener("click", (function() {
                        var e = this.dataset.id
                          , n = document.getElementById(e)
                          , o = Number(n.dataset.inc)
                          , l = t.qtyStep;
                        o > 0 && (l = o),
                        t.check_input(e, -1, -1 * l)
                    }
                    ));
                for (n = document.querySelectorAll(".nm-easywholesale-qty"),
                o = 0; o < n.length; o++)
                    n[o].addEventListener("keyup", (function() {
                        var e = this.dataset.id;
                        t.check_input(e, this.value, 0)
                    }
                    ));
                for (n = document.querySelectorAll(".nm-wholesale-btn-add-to-cart"),
                o = 0; o < n.length; o++)
                    n[o].addEventListener("click", (function() {
                        var n = this;
                        n.style.opacity = "0.4",
                        n.disabled = 1;
                        var o = {};
                        if (document.getElementById("product_form_product")) {
                            var l = document.getElementById("product_form_product").querySelectorAll("input, select");
                            for (const e of l)
                                if (e.name.indexOf("properties[") > -1) {
                                    o[e.name.replace("properties[", "").replace("]", "")] = e.value
                                }
                        }
                        for (var a = document.querySelectorAll(".nm-easywholesale-qty"), s = [], i = 0; i < a.length; i++)
                            if (1 * a[i].value > 0) {
                                let e = 1 * a[i].value
                                  , t = a[i].id.substring(3);
                                Object.keys(o).length > 0 ? s[i] = {
                                    quantity: e,
                                    id: t,
                                    properties: o
                                } : s[i] = {
                                    quantity: e,
                                    id: t
                                }
                            }
                        var d = "/";
                        void 0 !== window.Shopify.routes.root ? d = window.Shopify.routes.root : void 0 !== window.Shopify.routes.root_url && (d = window.Shopify.routes.root_url);
                        var r = 1;
                        "undefined" != typeof nm_easywholesale_goToCart_var && (r = nm_easywholesale_goToCart_var),
                        fetch(d + "cart/add.js?ignorecheck=true", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                items: s
                            })
                        }).then((e=>e.json())).then((function(o) {
                            if (void 0 === l)
                                var l = r;
                            if ("undefined" != typeof nm_easywholesale_goToCart && 1 == nm_easywholesale_goToCart && (l = 0),
                            "undefined" != typeof nm_easywholesale_cartCountId && fetch("/cart.json?ignorecheck=true").then((function(e) {
                                return e.json()
                            }
                            )).then((function(e) {
                                var t = e.item_count;
                                if (document.getElementById(nm_easywholesale_cartCountId))
                                    document.getElementById(nm_easywholesale_cartCountId).innerHTML = t + "";
                                else
                                    for (var n = document.querySelectorAll("." + nm_easywholesale_cartCountId), o = 0; o < n.length; o++)
                                        n[o].innerHTML = t + ""
                            }
                            )),
                            0 == l) {
                                for (var s = 0; s < a.length; s++)
                                    a[s].value = 0,
                                    a[s].disabled = !1,
                                    delete t.items[a[s].id];
                                e.add_to_cart_btn(0);
                                var i = document.createElement("div");
                                return i.classList.add("nm-wholesale-btn-add-to-cart"),
                                i.classList.add("nm-secondary-background-color"),
                                i.classList.add("nm-wholesale-stick-added"),
                                "undefined" != typeof nm_easywholesale_cartTextAdded ? i.innerHTML = nm_easywholesale_cartTextAdded : i.innerHTML = "Added",
                                document.body.append(i),
                                setTimeout((function() {
                                    i.remove()
                                }
                                ), 2e3),
                                "function" == typeof nm_easywholesale_custom_script_after_add && nm_easywholesale_custom_script_after_add(),
                                n.style.opacity = "1",
                                n.disabled = 0,
                                !1
                            }
                            "function" == typeof nm_easywholesale_custom_script_after_add && nm_easywholesale_custom_script_after_add(),
                            "undefined" != typeof nm_easywholesale_discount ? fetch("/discount/nm-ews-" + nm_easywholesale_discount + "?ignorecheck=true").then((e=>e.text())).then((function() {
                                window.location.href = 2 == l ? "/checkout/" : "/cart/"
                            }
                            )) : window.location.href = 2 == l ? "/checkout/" : "/cart/"
                        }
                        )).catch((e=>{
                            console.error("Error:", e)
                        }
                        ))
                    }
                    ));
                if (document.getElementById("nm-searchByProduct")) {
                    t = this;
                    document.getElementById("nm-searchByProduct").addEventListener("keyup", (function() {
                        t.updateListProductsAfterChangeFilter()
                    }
                    ))
                }
                for (n = document.querySelectorAll(".nm-view-other"),
                o = 0; o < n.length; o++) {
                    t = this;
                    n[o].addEventListener("click", (function() {
                        l(this.dataset.productid),
                        t.element_hide(this)
                    }
                    ))
                }
                function l(e) {
                    var t = document.getElementById("nm-wholesale-table-body-" + e);
                    if (t.style.maxHeight = "unset",
                    !(n = document.querySelectorAll(".nm-view-other[data-productid='" + e + "']"))[0] || "none" != n[0].style.display) {
                        var n, o = document.getElementById("nm-other-" + e);
                        if (o) {
                            t.style.display = "block",
                            t.style.overflow = "hidden";
                            var l = t.offsetHeight;
                            o.style.display = "block",
                            o.style.position = "relative",
                            o.style.opacity = "1",
                            o.style.zIndex = "1";
                            var a = t.offsetHeight + 50;
                            t.style.maxHeight = l + "px",
                            t.style.opacity = "1",
                            t.style.zIndex = "auto",
                            t.style.transition = "max-height 0.5s",
                            t.style.position = "inherit",
                            setTimeout((function() {
                                t.style.maxHeight = a + "px"
                            }
                            ), 100)
                        }
                        (n = document.querySelectorAll(".nm-view-collapse[data-productid='" + e + "']"))[0] && (n[0].style.display = "block")
                    }
                }
                window.addEventListener("scroll", (function(e) {
                    t.check_scroll()
                }
                ));
                for (n = document.querySelectorAll(".nm-easywholesale-popupfoto"),
                o = 0; o < n.length; o++) {
                    t = this;
                    n[o].addEventListener("click", (function() {
                        let e = this.dataset.img;
                        document.getElementById("nm-easywholesale-popup-img").style.width = "100px",
                        document.getElementById("nm-easywholesale-popup-img").style.animation = "spin 1s linear 0s infinite",
                        document.getElementById("nm-easywholesale-popup-img").src = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE1LjU0MiAxLjQ4N0EyMS41MDcgMjEuNTA3IDAgMCAwIC41IDIyYzAgMTEuODc0IDkuNjI2IDIxLjUgMjEuNSAyMS41IDkuODQ3IDAgMTguMzY0LTYuNjc1IDIwLjgwOS0xNi4wNzJhMS41IDEuNSAwIDAgMC0yLjkwNC0uNzU2QzM3LjgwMyAzNC43NTUgMzAuNDczIDQwLjUgMjIgNDAuNSAxMS43ODMgNDAuNSAzLjUgMzIuMjE3IDMuNSAyMmMwLTguMTM3IDUuMy0xNS4yNDcgMTIuOTQyLTE3LjY1YTEuNSAxLjUgMCAxIDAtLjktMi44NjN6IiBmaWxsPSIjOTE5RUFCIi8+PC9zdmc+Cg==";
                        var n = new Image;
                        n.src = e,
                        n.onload = function() {
                            document.getElementById("nm-easywholesale-popup-img").style.animation = "",
                            document.getElementById("nm-easywholesale-popup-img").src = e,
                            document.getElementById("nm-easywholesale-popup-img").style.width = "800px"
                        }
                        ,
                        t.element_show(document.getElementById("nm-easywholesale-popup-wrapper"))
                    }
                    ))
                }
            },
            check_scroll: function() {
                if (document.getElementById("nm-easywholesale-page-footer")) {
                    let t = document.getElementById("nm-easywholesale-page-footer").getBoundingClientRect().top
                      , n = document.getElementById("nm-wholesale-fix");
                    n.style.display = "block";
                    let o = n.getBoundingClientRect().top;
                    n.parentElement;
                    var e = !1;
                    void 0 !== layoutValues.addToCartSlicky && "0" == layoutValues.addToCartSlicky && (e = !0),
                    o > t || e ? n.style.display = "none" : (n.style.display = "block",
                    n.style.height = "auto")
                }
            },
            summaryOfTotalOrder: function() {
                var e = {
                    quantity: 0,
                    totalPrice: 0
                };
                Object.keys(this.items).length > 0 && (e.quantity = this.summaryOfTotalQuantity(),
                e.totalPrice = this.summaryOfTotalSum());
                for (var t = document.querySelectorAll(".nm-total-selected-items"), n = 0; n < t.length; n++)
                    t[n].innerHTML = e.quantity;
                for (t = document.querySelectorAll(".nm-total-summ-selected"),
                n = 0; n < t.length; n++)
                    t[n].innerHTML = this.formatMoney(e.totalPrice, layoutValues.money_format);
                document.getElementById("nm-total-selected-items") && (document.getElementById("nm-total-selected-items").innerHTML = e.quantity),
                document.getElementById("nm-total-summ-selected") && (document.getElementById("nm-total-summ-selected").innerHTML = this.formatMoney(e.totalPrice, layoutValues.money_format)),
                0 == e.quantity ? this.add_to_cart_btn(0) : this.add_to_cart_btn(1),
                "undefined" != typeof nm_easywholesale_discount && "free_shipping" == nm_easywholesale_discount_type && document.getElementById("nm-easywholesale-page-delivery") && (document.getElementById("nm-easywholesale-page-delivery").style.display = "flex",
                document.querySelector(".nm-easywholesale-selected-page-total").style.paddingBottom = "0px",
                document.querySelector(".nm-easywholesale-selected-page-delivery").style.paddingTop = "0px")
            },
            summaryOfTotalSum: function() {
                var e = this;
                return Object.keys(this.items).map((function(t) {
                    var n = e.items[t].price
                      , o = e.items[t].price;
                    return "undefined" != typeof nm_easywholesale_discount && ("percentage" != nm_easywholesale_discount_type && "fixed_amount" != nm_easywholesale_discount_type || ("percentage" == nm_easywholesale_discount_type ? o = n * (100 - nm_easywholesale_discount_value) / 100 : "fixed_amount" == nm_easywholesale_discount_type && (o = n - 100 * nm_easywholesale_discount_value) <= 0 && (o = 0))),
                    e.items[t].quantity * o
                }
                )).reduce((function(e, t) {
                    return e + t
                }
                ))
            },
            summaryOfTotalQuantity: function() {
                var e = this;
                return Object.keys(this.items).map((function(t) {
                    return e.items[t].quantity
                }
                )).reduce(((e,t)=>e + t), 0)
            },
            formatMoney: function(e, t) {
                var n = /\{\{\s*(\w+)\s*\}\}/;
                switch (t = t || this.money_format,
                "string" == typeof e && (e = e.replace(/[^0-9]/g, "")),
                (e = (e = parseInt(e)).toString()).length) {
                case 0:
                    e = "000";
                    break;
                case 1:
                    e = "00" + e;
                    break;
                case 2:
                    e = "0" + e
                }
                var o = e.substr(e.length - 2)
                  , l = e.substr(0, e.length - 2)
                  , a = ","
                  , s = ".";
                switch (t.match(n)[1]) {
                case "amount_no_decimals":
                    o = "",
                    s = "";
                    break;
                case "amount_with_comma_separator":
                    a = ".",
                    s = ",";
                    break;
                case "amount_no_decimals_with_comma_separator":
                    a = ".",
                    o = "",
                    s = ""
                }
                var i = function(e, t) {
                    return t = t || ",",
                    e.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t)
                }(l, a) + s + o;
                return t.replace(n, i)
            },
            smoothScrollTo: function(e, t) {
                var n, o, l, a = window.pageYOffset, s = e - window.pageYOffset;
                return t = t || 1e3,
                o = Date.now(),
                l = 0,
                n && clearInterval(n),
                n = setInterval((function() {
                    var e;
                    (l = (Date.now() - o) / t) >= 1 && (clearInterval(n),
                    l = 1),
                    e = l * s + a,
                    window.scrollBy(0, e - window.pageYOffset)
                }
                ), 10)
            }
        };
        if (e.init(),
        document.querySelector("body").addEventListener("updateEWS", (function() {
            e.init()
        }
        )),
        document.querySelectorAll(".nm-easywholesale-popupfoto").length > 0) {
            let e = document.createElement("div");
            e.setAttribute("id", "nm-easywholesale-popup-wrapper"),
            void 0 !== e.style && (e.style.display = "none"),
            e.addEventListener("click", (function() {
                document.getElementById("nm-easywholesale-popup-wrapper").style.display = "none"
            }
            )),
            e.innerHTML = '<div id="nm-easywholesale-inner-block" onclick="document.getElementById(\'nm-easywholesale-popup-wrapper\').style.display=\'none\';";><img id="nm-easywholesale-popup-img" src=""><a id="nm-easywholesale-popup-close" href="#" onclick="document.getElementById(\'nm-easywholesale-popup-wrapper\').style.display=\'none\'; return false;"><img width="50" height="50" src="//easywholesale.pages.dev/public/images/cross.svg"></a>',
            document.body.append(e),
            window.onkeydown = function(e) {
                27 == e.keyCode && (document.getElementById("nm-easywholesale-popup-wrapper").style.display = "none")
            }
        }
        window.onresize = function() {
            ("undefined" == typeof nm_easywholesale_show || nm_easywholesale_show) && e.set_height_all()
        }
    }()
}();
